import React from 'react'
import WatchSvg from '../../../img/svg/watch'
import { IconContainer } from './index.styled'

const ICONS = {
	'not-connected': { variant: 'neutral', icon: 'not-connected', testId: 'icon-not-connected' },
	generating: { variant: 'blue', icon: 'glyph', testId: 'icon-generating' },
	connecting: { variant: 'blue', icon: 'wifi', testId: 'icon-connecting' },
	connected: { variant: 'green', icon: 'check', testId: 'icon-connected' },
	'delete-confirm': { variant: 'red', icon: 'trash', testId: 'icon-delete-confirm' },
	deleting: { variant: 'red', icon: 'glyph', testId: 'icon-deleting' },
	deleted: { variant: 'red', icon: 'check', testId: 'icon-deleted' },
}

const StateIcon = React.memo(({ state }) => {
	const config = ICONS[state]
	if (!config) return null

	return (
		<IconContainer className={config.variant} data-testid={config.testId}>
			<WatchSvg icon={config.icon} />
		</IconContainer>
	)
})

StateIcon.displayName = 'StateIcon'
export default StateIcon
